var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6076 4.38833L16.5 0L3.3924 4.38833C2.40483 4.71903 1.54553 5.35563 0.936543 6.20772C0.32756 7.05982 -0.000136349 8.08407 4.25584e-08 9.135V19.985C4.25584e-08 32.525 15.18 39.45 15.8301 39.7383L16.4142 40L17.0214 39.7967C17.6748 39.5767 33 34.28 33 19.985V9.135C33.0001 8.08407 32.6724 7.05982 32.0635 6.20772C31.4545 5.35563 30.5952 4.71903 29.6076 4.38833ZM17.2326 23.3C16.9442 23.5933 16.6009 23.8258 16.2228 23.984C15.8446 24.1423 15.4391 24.223 15.0299 24.2217H14.9754C14.5578 24.2152 14.1458 24.1233 13.7643 23.9514C13.3829 23.7795 13.0399 23.5313 12.7561 23.2217L8.95125 19.2217L11.3322 16.9183L15.0348 20.8183L23.5834 12.1833L25.9166 14.54L17.2326 23.3Z",
    fill: "#006AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7bca66fd1f99d1b515a312f2954c1df5.svg";
export { ForwardRef as ReactComponent };